export default {"src":"https://images-cdn.curipod.com/d-db72cddc/_next/static/media/curiLogo.0c0d49a5.svg","height":298,"width":299};